import { motion } from "framer-motion";
import { INDUSTRIES } from "./data";
import { Eyebrow, MaskLines, EASE } from "./motion";

export const Industries = () => (
  <section id="industries" data-testid="industries-section" className="relative border-t border-white/10 bg-[#121212] py-24 lg:py-36">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Eyebrow index="02">Who we serve</Eyebrow>
          <MaskLines className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-[-0.03em] text-white sm:text-5xl" lines={["Built for", "buildings", <span className="text-brand-400">that work.</span>]} />
          <p className="mt-6 max-w-sm text-base leading-relaxed text-zinc-300">
            From showroom floors to distribution docks, we tailor every program to how your space is actually used.
          </p>
        </div>
      </div>
      <ul className="lg:col-span-8">
        {INDUSTRIES.map((ind, i) => (
          <motion.li
            key={ind.name}
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.06, ease: EASE }}
            data-testid={`industry-row-${i}`}
            className="industry-row group relative grid grid-cols-[auto_1fr] items-baseline gap-x-6 border-b border-white/10 py-8 sm:gap-x-10"
          >
            <span className="font-mono text-sm text-brand-400">0{i + 1}</span>
            <div>
              <h3 className="font-display text-2xl font-bold tracking-tight text-white transition-transform duration-500 group-hover:translate-x-3 sm:text-4xl">{ind.name}</h3>
              <p className="mt-2 text-sm text-zinc-400 transition-colors duration-500 group-hover:text-zinc-200 sm:text-base">{ind.note}</p>
            </div>
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
